import {PromotionType} from "../../../promotion/helpers/PromotionType";
import {IPromotionBoosterParams} from "../../types/booster_generic/IPromotionBooster";

export const isPromotionAvailable = (promotions?: IPromotionBoosterParams["promotions"], promotionType?: PromotionType) => {
    return Boolean(promotions && promotions.some((promotion) => promotion.type === promotionType));
};
import {PromotionType} from "../../../promotion/helpers/PromotionType";
import {IPromotionBoosterParams} from "../../types/booster_generic/IPromotionBooster";

export const isPromotionAvailable = (promotions?: IPromotionBoosterParams["promotions"], promotionType?: PromotionType) => {
    return Boolean(promotions && promotions.some((promotion) => promotion.type === promotionType));
};
